import { TbBookmark } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const BookmarkIcon = (props: IconProps) => {
  return <IconBase icon={TbBookmark} {...props} />;
};
